import PropTypes from 'prop-types';
import React from 'react';
import {Field} from 'redux-form';

import {StatusFilter} from '@utils/commonFilters/StatusFilter';
import Form from '@appComponents/ReduxFormControls';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';

export const ClientFilters = (props) => {
    const loading = props.loading,
        clientsFilters = props.filters.Clients,
        {
            clientTypes,
            countries,
            products,
        } = props.data;

    return (
        <div className='client__filters filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={clientsFilters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={loading}
                filters={clientsFilters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <Field
                component={Form.ReduxSelect}
                disabled={loading}
                loading={loading}
                multiple
                name='clientTypes'
                options={clientTypes}
                placeholder='Type'
                setValue={props.restoreFilterValues(clientsFilters, 'clientTypes')}
                search
            />
            <ProductsFilter
                products={products}
                loading={loading}
                filters={clientsFilters}
                restoreFilterValues={props.restoreFilterValues}
            />
            <Field
                className='--minimalWidth --isInternal'
                component={Form.ReduxSelect}
                disabled={loading}
                loading={loading}
                name='isInternal'
                options={[
                    {text: 'Internal', value: 1},
                    {text: 'Not internal', value: 0},
                ]}
                placeholder='Internal?'
                setValue={props.restoreFilterValues(clientsFilters, 'isInternal')}
            />
            <Field
                className='--minimalWidth --isStrategic'
                component={Form.ReduxSelect}
                disabled={loading}
                loading={loading}
                name='isStrategic'
                options={[
                    {text: 'Strategic', value: 1},
                    {text: 'Not strategic', value: 0},
                ]}
                placeholder='Strategic?'
                setValue={props.restoreFilterValues(clientsFilters, 'isStrategic')}
            />
            <StatusFilter
                loading={loading}
                filters={clientsFilters}
                restoreFilterValues={props.restoreFilterValues}
                statusType='IS_DISABLED'
                fieldName='isDisabled'
            />
        </div>
    );
};

ClientFilters.propTypes = {
    clientTypes: PropTypes.array,
    countries: PropTypes.array,
    loading: PropTypes.bool,
    products: PropTypes.array,
    data: PropTypes.object,
    filters: PropTypes.shape({
        Clients: PropTypes.object,
    }),
    restoreFilterValues: PropTypes.func.isRequired,
};

ClientFilters.defaultProps = {
    data: {
        clientTypes: [],
        countries: [],
        products: [],
    },
};

export default FiltersWrapper(ClientFilters, {name: 'Clients'});
